import Cookies from 'universal-cookie';

const cookies = new Cookies();

/**
 * Read cookie
 * @param {string} name The cookie's name
 * @return {*} The cookie's value
 */
const readCookie = name => {
  return cookies.get(name);
};

/**
 * set cookie
 * @param {Object} name The cookie's name
 * @param {array} value The cookie's value
 * @param {object} options options object
 * @return {*} The cookie's value or null if it doesn't exist
 */
const setCookie = (name: string, value: Array<*>, options: Object) => {
  cookies.set(name, value, options);
};

/**
 * delete cookie
 * @param {Object} name The cookie's name
 * @param {object} options options object
 * @return {*}
 */
const deleteCookie = (name: string, options: Object) => {
  cookies.remove(name, options);
};
/**
 * Produce cookie options
 * @return {object} - cookie options object
 */
const options = () => {
  const currentDate = new Date();
  let cookieOptions = {
    path: '/',
    expires: new Date(currentDate.setDate(currentDate.getDate() + 60))
  };

  return cookieOptions;
};

export { readCookie, setCookie, deleteCookie, options };



// WEBPACK FOOTER //
// ./src/utils/cookies.js